export default "__VITE_ASSET__cuFNFfSi__"